<header>
    <nav #navbar class='main-panel navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-dark border-bottom box-shadow'>
        <div class="container-fluid">
            <!-- <a class="navbar-brand" [routerLink]='["/"]'></a> -->
            <img [src]="EurofinsIconPath">
            @if (!CoreData.IsMobile) {
            <div class="mx-3 bar-separator"></div>
            }
            @if (!CoreData.IsMobile) {
            <span class="mx-3 white title-size"> {{AppName}}</span>
            }
            <span class="mx-3 white title-size"> {{getUserProfileLabel()}} </span>
            <button #toggleButton class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded"
                    (click)="toggle()">
                <span class="navbar-toggler-icon"></span>
            </button>
            <!-- MOBILE UI -->

            <!-- DESKTOP UI -->
            @if (IsLoggedIn()) {
            <div class="collapse navbar-collapse justify-content-end">
                <ul class="navbar-nav ml-auto row align-items-center g-0">
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/sample-list"]'>
                            <div>
                                <mat-icon class="material-symbols-outlined">science</mat-icon>
                            </div>
                            <div class="" i18n>
                                Echantillons
                            </div>
                        </a>
                    </li>
                    @if (!IsTechnicien) {
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/config-list"]'>
                            <div>
                                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                            </div>
                            <div class="" i18n>
                                Formats d'export
                            </div>
                        </a>
                    </li>
                    }
                    @if (IsAdmin) {
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/user"]'>
                            <div>
                                <mat-icon class="material-symbols-outlined">group</mat-icon>
                            </div>
                            <div class="" i18n>
                                Utilisateurs
                            </div>
                        </a>
                    </li>
                    }
                    <li class="nav-item col-auto clickable" [routerLinkActive]='["link-active"]' (click)="logout()">
                        <a class="nav-link row g-0 p-0" [routerLink]=''>
                            <div>
                                <mat-icon class="material-symbols-outlined">logout</mat-icon>
                            </div>
                            <div class="" i18n>
                                Déconnexion
                            </div>
                        </a>
                    </li>
                </ul>

            </div>

            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon class="material-symbols-outlined white" >more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <div mat-menu-item class="text-center unclickable" (click)="$event.stopPropagation()">
                    Version: {{AppVersion}}
                </div>
                <div mat-menu-item class="text-center unclickable" (click)="$event.stopPropagation()">
                    <div>{{CoreData.User?.FirstName}} {{CoreData.User?.LastName}}</div>
                </div>
                <button mat-menu-item (click)="getSpecificFiles()">
                    <mat-icon class="material-symbols-outlined">description</mat-icon>
                    <span>CGU RGPD</span>
                </button>
            </mat-menu>
            }
            @if (!IsLoggedIn()) {
            <div class="collapse navbar-collapse header-height">
                <!-- This a dummy container to align the header -->
            </div>
            }
        </div>
    </nav>
    <mat-progress-bar [style.opacity]="Opacity" mode="indeterminate" color="accent" role="progressbar"
                      class="on-top">
    </mat-progress-bar>
</header>